var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _vm.jage == 1
                ? _c("div", { staticClass: "div2" }, [_vm._v("客户被退货")])
                : _vm._e(),
              _vm.jage == 0
                ? _c("div", { staticClass: "div2" }, [_vm._v("填写拒收详情")])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "orderInfo" }, [
      _vm._m(0),
      !_vm.is_null(_vm.content.orderUser)
        ? _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v(
                    "订单编号: " + _vm._s(_vm.content.orderUser.orderIdStr)
                  ),
                ]),
                _c("span", { staticClass: "span" }, [
                  _vm._v(
                    "订单状态: " + _vm._s(_vm.content.orderUser.orderType)
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "span",
                    staticStyle: { display: "inline-block" },
                  },
                  [
                    _c("span", { staticClass: "span1" }, [_vm._v("时 间")]),
                    _c("span", [
                      _vm._v(":" + _vm._s(_vm.content.orderUser.createdTime)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "span",
                    staticStyle: { display: "inline-block" },
                  },
                  [
                    _c("span", { staticClass: "span1" }, [_vm._v("客 服:")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.content.orderUser.employeeName)),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v(
                    "客户信息: " +
                      _vm._s(_vm.content.orderUser.customerUserName) +
                      " " +
                      _vm._s(_vm.content.orderUser.customerUserPhone) +
                      " " +
                      _vm._s(_vm.content.orderUser.detailedAddress)
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v(
                    "收货信息: " +
                      _vm._s(_vm.content.orderUser.addressName) +
                      " " +
                      _vm._s(_vm.content.orderUser.addressPhone) +
                      " " +
                      _vm._s(_vm.content.orderUser.address)
                  ),
                ]),
              ]),
            ]),
            _vm._m(1),
            _vm.jage == 0
              ? _c("div", { staticClass: "contentTemp" }, [
                  _c("div", { staticClass: "fontTemp" }, [
                    _c("span", { staticClass: "span" }, [
                      _vm._v(
                        "包裹单号: " +
                          _vm._s(
                            _vm.content.orderUser.logisticsOrder
                              .logisticsCompany
                          ) +
                          " " +
                          _vm._s(
                            _vm.content.orderUser.logisticsOrder.parcelNumber
                          )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.jage == 1
              ? _c("div", { staticClass: "contentTemp" }, [
                  _c("div", { staticClass: "fontTemp" }, [
                    _vm._m(2),
                    _c(
                      "div",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "快递公司",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.logisticsCompany,
                              callback: function ($$v) {
                                _vm.logisticsCompany = $$v
                              },
                              expression: "logisticsCompany",
                            },
                          },
                          _vm._l(_vm.companys, function (itemsS) {
                            return _c("el-option", {
                              key: itemsS.dictName,
                              attrs: {
                                label: itemsS.dictName,
                                value: itemsS.dictName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            placeholder: "请输入包裹物流单号",
                          },
                          model: {
                            value: _vm.logistCode,
                            callback: function ($$v) {
                              _vm.logistCode = $$v
                            },
                            expression: "logistCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "goodDetail" }, [
      _c("div", { staticClass: "title" }, [_vm._v("商品详情")]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title", staticStyle: { border: "0" } }, [
            _vm._v("商品"),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.content.orderCommodityList,
                "header-cell-style": { color: "#333", textAlign: "center" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: { width: "200", prop: "name", label: "商品名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "原单数量" },
              }),
              _c("el-table-column", {
                attrs: { label: "仓库收货", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "optain" }, [
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("已收")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.receivedNum,
                                      min: 1,
                                      max: scope.row.receivedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changCountRecived(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.receivedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "receivedNum", $$v)
                                      },
                                      expression: "scope.row.receivedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecived(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecived(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("破损")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.damagedNum,
                                      min: 1,
                                      max: scope.row.damagedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountDamage(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.damagedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "damagedNum", $$v)
                                      },
                                      expression: "scope.row.damagedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamage(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamage(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("漏件")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.missingNum,
                                      min: 1,
                                      max: scope.row.missingNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountMissing(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.missingNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "missingNum", $$v)
                                      },
                                      expression: "scope.row.missingNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissing(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissing(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ￥" + _vm._s(scope.row.price) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "规格" },
              }),
              _vm.jage == 0
                ? _c("el-table-column", {
                    attrs: { label: "拒收小计" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" ￥" + _vm._s(scope.row.total) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1133241818
                    ),
                  })
                : _vm._e(),
              _vm.jage == 1
                ? _c("el-table-column", {
                    attrs: { label: "退货小计" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" ￥" + _vm._s(scope.row.total) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1133241818
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "title", staticStyle: { border: "0" } }, [
            _vm._v("赠品"),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.content.orderComplimentaryList,
                "header-cell-style": { color: "#333", textAlign: "center" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  prop: "complimentaryName",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "原单数量" },
              }),
              _c("el-table-column", {
                attrs: { label: "仓库收货", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "optain" }, [
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("已收")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.receivedNum,
                                      min: 1,
                                      max: scope.row.receivedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changCountRecivedZp(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.receivedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "receivedNum", $$v)
                                      },
                                      expression: "scope.row.receivedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecivedZp(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecivedZp(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("破损")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.damagedNum,
                                      min: 1,
                                      max: scope.row.damagedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountDamageZp(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.damagedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "damagedNum", $$v)
                                      },
                                      expression: "scope.row.damagedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamageZp(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamageZp(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("漏件")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.missingNum,
                                      min: 1,
                                      max: scope.row.missingNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountMissingZp(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.missingNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "missingNum", $$v)
                                      },
                                      expression: "scope.row.missingNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissingZp(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissingZp(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ￥" + _vm._s(scope.row.price) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "规格" },
              }),
              _vm.jage == 0
                ? _c("el-table-column", {
                    attrs: { label: "拒收小计" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" ￥" + _vm._s(scope.row.total) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1133241818
                    ),
                  })
                : _vm._e(),
              _vm.jage == 1
                ? _c("el-table-column", {
                    attrs: { label: "退回小计" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" ￥" + _vm._s(scope.row.total) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1133241818
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          !_vm.is_null(_vm.content.orderUser)
            ? _c("div", { staticClass: "totalAll" }, [
                _c("span", [
                  _vm._v(
                    "原单总计：共" +
                      _vm._s(_vm.content.orderUser.pieceNumber) +
                      "件"
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    "运费：" + _vm._s(_vm.content.orderUser.charge) + "元"
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    "赠品总价 ￥ " + _vm._s(_vm.content.orderUser.giftTotal)
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    "商品总价 ￥ " + _vm._s(_vm.content.orderUser.goodsTotal)
                  ),
                ]),
                _c("span", [
                  _vm._v("应收金额 ￥ " + _vm._s(_vm.content.orderUser.total)),
                ]),
                _c("span", [
                  _vm._v(
                    "已收金额 ￥ " + _vm._s(_vm.content.orderUser.receivedMoney)
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    "待收金额 ￥ " +
                      _vm._s(_vm.content.orderUser.awaitIncomeMoney)
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content.orderUser)
            ? _c("div", { staticClass: "totalAll" }, [
                _c("span", [_vm._v("仓库收货总计")]),
                _c("span", [
                  _vm._v("已收 " + _vm._s(_vm.receivedTogether) + " 件"),
                ]),
                _c("span", [
                  _vm._v("破损 " + _vm._s(_vm.damagedTogether) + " 件"),
                ]),
                _c("span", [
                  _vm._v("漏件 " + _vm._s(_vm.missingTogether) + " 件"),
                ]),
                _c("span", [
                  _vm._v(
                    "已收货总价 ￥ " + _vm._s(_vm.content.orderUser.total)
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "remark" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("备注")]),
        _c("el-input", {
          attrs: { type: "textarea", rows: 2, placeholder: "请输入内容" },
          model: {
            value: _vm.textarea,
            callback: function ($$v) {
              _vm.textarea = $$v
            },
            expression: "textarea",
          },
        }),
      ],
      1
    ),
    _c("div", { staticStyle: { height: "70px" } }),
    _vm.jage == 0
      ? _c(
          "div",
          { staticClass: "submit" },
          [
            _c(
              "el-button",
              {
                staticStyle: { width: "100px" },
                attrs: { type: "primary", size: "mini" },
                on: {
                  click: function ($event) {
                    return _vm.submitEvent()
                  },
                },
              },
              [_vm._v("提交")]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.jage == 1
      ? _c(
          "div",
          { staticClass: "submit" },
          [
            _c(
              "el-button",
              {
                staticStyle: { width: "100px" },
                attrs: { type: "primary", size: "mini" },
                on: {
                  click: function ($event) {
                    return _vm.submitEvent()
                  },
                },
              },
              [_vm._v("提交被退货")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("订单信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contentTemp" }, [
      _c("div", { staticClass: "fontTemp" }, [
        _c("span", { staticClass: "span" }, [_vm._v("物流备注: 无")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("*")]), _vm._v("物流公司:")])
  },
]
render._withStripped = true

export { render, staticRenderFns }